export const ignoreHeaderNames = new Set([
  "Current Weeks",
  "Current Week",
  "Previous Weeks",
  "Next Weeks",
  "Current Month",
  "Current Months",
  "Previous Months",
  "Next Months"
]);
export function rowFormatterToChangeFieldToHeaderName(
  row: any,
  HeaderNameToColObj: Record<string, any>
) {
  const transformed: any = {
    id: row?.id,
    l_id: row?.l_id,
    isAzureRow: row?.isAzureRow,
  };

  if (!row) return transformed;

  for (const field of Object.keys(row)) {
    const colDef = HeaderNameToColObj[field];
    if (!colDef && (field !== 'predecessorNodes' && field !== 'successorNodes')) continue;
    if (field === 'predecessorNodes' || field === 'successorNodes') transformed[field] = row[field];
    else {
      if (colDef.colId === "#" || colDef.block) continue;
      const headerName = colDef.headerName;

      if (ignoreHeaderNames.has(headerName)) continue;

      const rawValue = row[field];

      // THIS IS THE IMPORTANT PART
      const displayValue = computeDisplayValue(field, rawValue, colDef);

      transformed[headerName] = displayValue;
    }
  }

  return transformed;
}
function computeDisplayValue(field: string, value: any, colDef: any) {
  if (!value) return "";

  // Handle PERSON column
  if (colDef?.type === "person" || colDef?.type === "Assignee") {
    try {
      const arr = typeof value === "string" ? JSON.parse(value) : value;

      if (!Array.isArray(arr)) return "";

      return arr
        .map((p: any) => p?.username)
        .filter(Boolean)          // remove empty / undefined usernames
        .join(", ");
    } catch {
      return "";
    }
  }


  // Handle MULTIDIMENSIONAL (timeseries)
  if (colDef?.type === "multi dimensional value" && colDef.block) {
    return "";
  }
  if (colDef?.type === "multi dimensional value") {

    const parsedValue = JSON.parse(value);
    return parsedValue
      .filter(obj => obj.propValue !== "" && obj.propValue !== null && obj.propValue !== undefined) // Filter out objects with empty propValue
      .map(obj => {
        const propValue = Array.isArray(obj.propValue)
          ? `(${obj.propValue.join(", ")})`
          : obj.propValue || '';

        return `${obj.propName} [${obj.propAbbrevation}] [${obj.propType}]: ${propValue}`;
      })
      .join(", ");
  };

  // Handle SHAREABLE ROLLUP LIST
  if (colDef?.type === "shareableRollupList") {
    try {
      const obj = JSON.parse(value);
      return obj.value ?? "";
    } catch {
      return value ? value : '';

    }
  }

  // Handle DROPDOWN with custom delimiter
  if (typeof value === "string" && value.includes("⊗⇔≈")) {
    return value.split("⊗⇔≈").join(", ");
  }

  // Default: return value directly
  return value;
}
// Stable color palette
const SUBLANE_COLORS = [
  "#E57373", // red
  "#64B5F6", // blue
  "#81C784", // green
  "#FFD54F", // yellow
  "#BA68C8", // purple
  "#4DB6AC", // teal
  "#FF8A65", // orange
  "#90A4AE", // grey
];

// Cache so same subgroup always gets same color
const subLaneColorMap = new Map<string, string>();

export function getSubLaneColor(subgroup: string) {
  if (!subgroup) return "#E0E0E0";

  if (subLaneColorMap.has(subgroup)) {
    return subLaneColorMap.get(subgroup)!;
  }

  const color = SUBLANE_COLORS[subLaneColorMap.size % SUBLANE_COLORS.length];
  subLaneColorMap.set(subgroup, color);
  return color;
}
export function convertRowIdStringToRowIndex(value, rowIdToIndexMap) {
  if (!value || typeof value !== "string") return value;

  return value
    .split(",")
    .map(function (token) {
      const trimmed = token.trim();

      // rowId OR rowId+2d
      const match = trimmed.match(/^([^+]+)(\+\d+[a-z])?$/i);

      if (!match) return trimmed;

      const rowId = match[1];
      const suffix = match[2] || "";

      const rowIndex = rowIdToIndexMap[rowId];

      return rowIndex ? rowIndex + suffix : trimmed;
    })
    .join(", ");
}
